<template>
  <div class="modal-recharge">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">选择老人</div>
        <div style="folat:right">
          <el-button type="danger" @click="closeSelf">关闭</el-button>
        </div>
      </div>
      <div class="modal-body" :style="bodyStyle">
        <el-row>
          <el-form :model="searchForm" inline ref="searchForm">
            <div>
              <el-col :span="24">
                <el-form-item prop="name">
                  <el-input  placeholder="请输入姓名" v-model="searchForm.name" clearable style="width:200px;margin-right:10px"></el-input>
                </el-form-item>
                <el-button  type="primary" icon="el-icon-search" @click="getElderly">搜索</el-button>
              </el-col>
            </div>
          </el-form>
        </el-row>
        <el-row style="margin-top:20px">
          <el-col :span="24">
            <el-table
                :data="elderlyInfo"
                style="width: 100%" border :height="th">

              <el-table-column label="姓名" prop="name" width="100"></el-table-column>
              <el-table-column label="手机号" prop="phone"></el-table-column>
              <el-table-column label="身份证号" prop="idCard"></el-table-column>
              <el-table-column label="地址" prop="areaName" ></el-table-column>
              <el-table-column label="详细住址" prop="address" ></el-table-column>
              <el-table-column prop="balance"  width="100" label="余额(元)"></el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="primary" size="small" @click.native.prevent="handleRecharge(scope.row)">添加</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <div style="text-align: left;background-color: #fff;padding: 10px;">
          <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/searchForm.pageSize)}}页）
          </div>
          <div style="float: left;">
            <el-pagination
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="20"
                @current-change="current_change">
            </el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: 'Add',
  props:['zoneValue'],
  data() {
    return {
      multipleSelection:'',
      checked:false,
      loading: false,
      elderlyInfo:[],
      elderlyRow:'',
      statusValue:['全部状态','正常','禁用'],
      totalItems:0,
      searchForm:{
        name:'',
        status:-1,
        checkinStatus:2,
        pageSize:20,
        pageIndex:1,
      },
      bodyStyle:"height:"+(this.$store.state.tableHeight+50)+'px',
      th:this.$store.state.tableHeight-30,
      successInfo:''
    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.bodyStyle = "height:"+(val+50)+'px';
      this.th=val-30
    },
  },
  components:{
  },
  methods: {
    init(){
      this.$refs.searchForm.resetFields()
      this.getElderly()
    },
    formatterTime(cellValue) {
      return timefilters(cellValue)
    },
    closeSelf() {
      this.$emit("closeAdd");
    },
    getList(){
      this.$emit("getList");
      this.getElderly();
    },
    current_change:function(currentPage){
      this.searchForm.pageIndex = currentPage;
      this.getElderly();
    },
    handleRecharge(row) {
      this.elderlyRow=row
      this.$prompt( '请输入药品名称和数量', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType:'textarea',
        inputPlaceholder:'请输入药品名称和数量'
      }).then(({ value }) => {
        if(value){
          this.setRefundRecord(row.elderlyCode,value)
        }else{
          this.$message.error('请输入药品名称和数量')
        }
      }).catch(() => {
        //this.$message({type: 'info', message: '取消输入'});
      });
    },
    setRefundRecord(code,value){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"ElderlyDrugRecord/Add",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          elderlyCode:code,
          remarks:value
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              this.$message({type: 'success', message: '添加成功!'});
              this.$emit('getList')
              this.closeSelf()
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )

    },
    allStatus(row,status){
      for(var i in status){
        if(status[i].value==row){
          return status[i].label
        }
      }
      return "其它";
    },
    getElderly(){
      this.searchForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
      this.searchForm.timeStr = timeStr
      this.searchForm.staffCode = getStaffCode()
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Elderly/InsPageCheckin",
        data: this.searchForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.elderlyInfo=response.data.data.pageInfo.list;
              this.totalItems = response.data.data.pageInfo.total;
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },

  }
}


</script>





<style lang="scss" scoped>

.modal-recharge {
  position: fixed;
  top: 50px;
  right: 0;
  bottom: 0;
  left: 200px;
  background-color: rgba(0,0,0,.3);
  display: flex;
  z-index: 99;
  .dialog /deep/ .is-disabled .el-input__inner {
    background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: #000;
    cursor: not-allowed;
  }
  .text{
    font-size: 16px;
    line-height: 25px;
  }
  .modal {
    background-color: #fff;
    box-shadow:  none;
    border-radius: 0;
    width: 100%;

    .modal-header {
      border-bottom: 1px solid #eee;
      color: #313131;
      justify-content: space-between;
      padding: 10px;
      display: flex;
    }

    .modal-body {
      position: relative;
      padding: 20px 20px 0;
      z-index: 99;
    }
    .modal-body /deep/ .el-card.is-always-shadow{
      box-shadow:none;
      border-bottom: none;
      margin-bottom: 20px;
    }
    .modal-body /deep/ .el-form-item{
      margin: 0 5px 0 0;
    }
    .modal-footer {
      border-top: 1px solid #eee;
      justify-content: center;
      padding: 15px;
      display: flex;
      .el-button{
        width: 15%;
      }
    }


  }

}


.btn-close, .btn-confirm {
  border-radius: 8px;
  margin-left:16px;
  width:56px;
  height: 36px;
  border:none;
  cursor: pointer;
}
.btn-close {
  color: #313131;
  background-color:transparent;
}



.row{
  padding: 10px 0px;
}
.item{
  padding: 0px 20px;
}
.label{
  padding: 5px 0px;
}


</style>
